import { useQuery } from '../useQuery/useQuery'

import { getCalendarIntegrationStatus } from '@percent/workplace-giving/api/calendar/getCalendarIntegrationStatus'

export const useCalendarIntegrationStatus = (options?: { refetchOnWindowFocus?: boolean }) =>
  useQuery(['getCalendarIntegrationStatus'], getCalendarIntegrationStatus, options)
